import Camera from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera.png';
import Camera1 from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera1.png';
import Camera2 from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera2.png';
import Camera3 from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera3.png';
import Camera4 from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera4.png';
import Camera5 from '../../routes/SmartInspect/Montgomery/assets/maintenance/camera5.png';
import PDP from '../../routes/SmartInspect/Warren/assets/equipment/3.12-PDP.png';

import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item class="d-flex">
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					<left>
						<h2 style={{ width: '50%', margin: 'auto' }}>
							Before replacing a camera make sure to first troubleshoot the issue in the <a href="#">Camera Troubleshooting</a> section of this manual to ensure replacement is necessary.
						</h2>
					</left>
				</BSCarousel.Caption>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					<p>
						Perform system power down/lock out as outlined in this manual and on the lock out placard located on the front of the <b>PDP</b>.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={PDP} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: PDP</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					<p>
						Before removing the power or data cables from the camera ensure the power is OFF. The power/comm/status indicator lights located on the back of the camera should be off (see <b>Figure 1: Camera Overview for locations</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera1} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 4</h3>
					<p>Remove the data cable by pinching tab and pulling outward.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera2} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					<p>
						Remove the power cable by sliding connector collar upward to release cable and pull outward, the connector does <b>NOT</b> unscrew.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera3} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					<p>
						Locate the three metric Allen mounting screws on the bottom of the camera that connect the camera body to the camera mount. There is a mark on the camera mount notating the location of the screws, if the mark is missing make sure to mark the current location of the screws before removal to ensure proper alignment during reinstallation (see <b>Figure 1: Camera Overview</b> for screw locations).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera4} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					<p>Remove the three metric Allen screws, make note to be gentle and do not strip the screw heads as you will be reusing them on the new camera. Be sure not to drop the camera or touch the glass portion of the lens as it is a very sensitive piece of equipment.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera4} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 8</h3>
					<p>Before the lens removal, ensure the F-stop thumb screw and focus lock ring set screw are both securely tight (see Figure 1: Camera Overview for locations).</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera5} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>
							<b>Figure 1: Camera Overview</b>
						</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 9</h3>

					<h3 style={{ width: '50%', margin: 'auto' }}>
						Be sure to have the new camera prepped and ready for installation of the lens assembly.
						<br />
						<br />
						Dust or debris must not be allowed to enter into the camera body, do NOT attempt to wipe or touch the photo sensor within the camera body as this may cause permanent damage to the camera.
						<br />
						<br />
						You may use compressed canned air to gently blow out any dust or debris should any enter the camera body prior to installing the lens assembly.
					</h3>
				</BSCarousel.Caption>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 10</h3>
					<p>Carefully remove the lens from the old camera by grasping the silver lock ring by hand and unscrewing the lens assembly as a whole counter clockwise. Make sure not to touch the glass portion of the lens.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 11</h3>
					<p>Remove the dust cap of the new camera and Install onto the old camera.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 12</h3>
					<p>Install the lens assembly onto the new camera by gently screwing the lens into the camera body clockwise until it is completely flush with the camera body, this should be done by hand without the use of tools ensuring it is securely threaded in place.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 13</h3>
					<p>
						Install the camera onto the camera mount using the three metric Allen screws, ensure proper alignment with the marks on the mount located/notated during step 3. Be sure <b>NOT</b> to over tighten the three metric Allen screws.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera4} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 14</h3>
					<p>
						Install the power cable by aligning the connector notches with the cameras power port and press into place until the collar locks down into place. The cable/connector does <b>NOT</b> screw in.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera3} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 15</h3>
					<p>Install the data cable into the cameras data cable port by aligning the tab and pressing in until the tab locks into place.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera2} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 16</h3>
					<p>Be sure to check both the power and data connections to ensure they are secure before powerup.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 17</h3>
					<p>Perform unlock procedure and restore power to the system.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={PDP} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: PDP</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 18</h3>
					<p>The indicator lights on the back of the camera will now be illuminated.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={Camera1} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Camera Overview</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const AlliedCameraSMP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	.carousel-inner {
		border-radius: 2em;
		min-height: 50vh;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-control-prev,
	.carousel-control-next {
		min-height: 60vh;
	}

	.carousel-caption {
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;
		& h3 {
			text-align: center;
		}
	}

	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default AlliedCameraSMP;
